"use client";

import React, { memo } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function QueEsUnAlquimico() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="223083" id="the-jiahe-experience" className="bg-background py-20 px-6 md:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-accent/20 rounded-full blur-[60px] pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="lg:col-span-5 relative flex justify-center">
          <div className="relative w-full max-w-[400px] aspect-square">
            {}
            <div className="absolute inset-[-5%] rounded-full border border-accent/40 animate-[spin_80s_linear_infinite] will-change-transform" />
            <div className="absolute inset-[-10%] rounded-full border border-secondary/20 animate-[spin_50s_linear_infinite_reverse] will-change-transform" />
            
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/jim_yang_portrait.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/jim_yang_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/jim_yang_portrait.png-wvc-sizes" alt="Jim Yang, Guizhou travel expert portrait" loading="lazy" className="w-full h-full object-cover rounded-full shadow-xl shadow-primary/10 relative z-10" />
            
            {}
            <div className="absolute inset-0 rounded-full shadow-[inset_0_0_40px_rgba(212,175,55,0.1)] z-20 pointer-events-none" />
          </div>
        </div>

        {}
        <div className="lg:col-span-7 flex flex-col gap-6">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-primary tracking-tight">
            The Jiahe Standard
          </h2>
          
          <div className="space-y-6 text-foreground/90 font-default text-lg leading-relaxed">
            <p>
              At Guizhou Voyage, we believe that true travel is an art of connection. Led by Jim Yang, our team serves as your personal gateway to the hidden wonders of Southwest China. We don't just book tours; we curate immersive journeys that bridge the gap between curious travelers and the ancient traditions of Guizhou's ethnic minorities.
            </p>
            
            {}
            <blockquote className="bg-accent/30 border-l-4 border-secondary p-6 rounded-r-lg my-8 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-secondary/5 rounded-full blur-2xl -mr-16 -mt-16 pointer-events-none" />
              <p className="text-primary font-medium text-xl relative z-10 italic">
                "Our mission is to reveal the authentic soul of Guizhou through private, expert-led experiences that honor both the landscape and the local heritage."
              </p>
              <cite className="block mt-2 text-sm font-mono text-secondary">— Jim Yang, Founder</cite>
            </blockquote>
            
            <p>
              From the misty karst peaks to the vibrant festivals of the Miao and Dong people, every itinerary is crafted with the precision of local expertise and the warmth of genuine hospitality. We combine modern comfort with deep cultural respect to ensure your voyage is as seamless as it is transformative.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
export default memo(QueEsUnAlquimico);